// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIwIDIwIj48ZyBmaWxsPSIjMmYzMjM3Ij48cGF0aCBkPSJNOS41IDYuNWEuNS41IDAgMSAxIDEgMHYzaDIuOTk4YS41LjUgMCAwIDEgMCAxLjAwMUgxMC41djNhLjUuNSAwIDAgMS0xIDB2LTNoLTNhLjUuNSAwIDEgMSAwLTEuMDAxaDN6Ii8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAgM2E3IDcgMCAxIDEgMCAxNCA3IDcgMCAwIDEgMC0xNHptMCAxYTYgNiAwIDEgMCAwIDEyIDYgNiAwIDAgMCAwLTEyeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: "IBM Plex Sans" !important;
}

body>iframe {
    display: none;
}

.scroll-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    will-change: transform;
}

li::marker {
    display: inline-block;
    vertical-align: top;
}

.ga-pill-box__item--select {
    cursor: pointer;
    display: inline-flex;
    width: -webkit-fit-content;
    width: fit-content;

}

.ga-pill-box__item--select::before {
    content: attr(title);
    pointer-events: none;
}

.ͼ42 {
    background-color: transparent !important;
}

.shape-box {
    border-bottom-left-radius: 100% 250px;
    border-bottom-right-radius: 100% 250px;
    width: calc(100% + 100px);
    margin-left: -50px;
    overflow: hidden;
}

.ga-pill-box__item--select select {
    padding: 0;
    margin: 0;
    border: none;
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    cursor: pointer;
}


.ga-icon__add-circle {
    background-position: 8px center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/*  */
.message-container>.day-0~.day-0>.date-header {
    display: none;
}

.message-container>.day-1~.day-1>.date-header {
    display: none;
}

.message-container>.day-2~.day-2>.date-header {
    display: none;
}

.message-container>.day-3~.day-3>.date-header {
    display: none;
}

.message-container>.day-4~.day-4>.date-header {
    display: none;
}

.message-container>.day-5~.day-5>.date-header {
    display: none;
}

.message-container>.day-6~.day-6>.date-header {
    display: none;
}

.message-container>.day-7~.day-7>.date-header {
    display: none;
}

.message-container>.day-8~.day-8>.date-header {
    display: none;
}

.message-container>.day-9~.day-9>.date-header {
    display: none;
}

.message-container>.day-10~.day-10>.date-header {
    display: none;
}

.message-container>.day-11~.day-11>.date-header {
    display: none;
}

.message-container>.day-12~.day-12>.date-header {
    display: none;
}

.message-container>.day-13~.day-13>.date-header {
    display: none;
}

.message-container>.day-14~.day-14>.date-header {
    display: none;
}

.message-container>.day-15~.day-15>.date-header {
    display: none;
}

.message-container>.day-16~.day-16>.date-header {
    display: none;
}

.message-container>.day-17~.day-17>.date-header {
    display: none;
}

.message-container>.day-18~.day-18>.date-header {
    display: none;
}

.message-container>.day-19~.day-19>.date-header {
    display: none;
}

.message-container>.day-20~.day-20>.date-header {
    display: none;
}

.message-container>.day-21~.day-21>.date-header {
    display: none;
}

.message-container>.day-22~.day-22>.date-header {
    display: none;
}

.message-container>.day-23~.day-23>.date-header {
    display: none;
}

.message-container>.day-24~.day-24>.date-header {
    display: none;
}

.message-container>.day-25~.day-25>.date-header {
    display: none;
}

.message-container>.day-26~.day-26>.date-header {
    display: none;
}

.message-container>.day-27~.day-27>.date-header {
    display: none;
}

.message-container>.day-28~.day-28>.date-header {
    display: none;
}

.message-container>.day-29~.day-29>.date-header {
    display: none;
}

.message-container>.day-30~.day-30>.date-header {
    display: none;
}

/* start of react flow */
.wmde-markdown {
    font-family: "Rubik", sans-serif !important;
}

.workflow-panel-animation .react-flow__viewport {
    transition: transform 0.3s ease-in-out;
}

.workflow-node-animation .react-flow__node {
    transition: transform 0.2s ease-in-out;
}

.md-editor-toolbar-warp {
    border: none !important;
}

.react-flow__attribution {
    position: absolute;
    bottom: 0px;
    right: 0px;
}



/* input[type="radio"]:checked + span {
  display: block; */
/* } */

.gridBody {
    fill: white
}

.monaco-editor {
    position: absolute !important;
}

.normal-text .ͼ1 .cm-scroller {
    font-family: "Rubik", sans-serif !important;
}

.cm-content {
    white-space: pre-wrap !important;

}

.markdown-editor .cm-line {
    font-family: "Rubik", sans-serif;
}

.cm-line .cm-placeholder {
    opacity: 0.5;
    color: rgb(71 85 105 / var(--tw-text-opacity));
}

.monaco-editor,
.monaco-editor-background {
    background: transparent !important
}

.markdown-viewer-with-uiw .wmde-markdown {
    font-family: "Rubik", sans-serif;
}

.monaco-editor .margin-view-overlays .current-line,
.monaco-editor .view-overlays .current-line {
    border: none !important;
}

.cm-scroller {
    line-height: 30px !important;
}

.margin-view-overlays {
    padding-left: 10px;
}

/* hide readonly tooltip */
.monaco-editor-overlaymessage {
    display: none !important;
}

.cm-editor {
    outline: none !important;

}

.md-editor-content {
    border-radius: 10px;
}

.full-screen .cm-editor {
    height: 78vh !important;
}


.st0 {
    display: none;
}

.st1 {
    display: inline;
}

.st2 {
    opacity: 0.29;
}

.st3 {
    fill: #FFFFFF;
}

.st4 {
    -webkit-clip-path: url(#SVGID_2_);
            clip-path: url(#SVGID_2_);
    fill: #FFFFFF;
}

.st5 {
    -webkit-clip-path: url(#SVGID_4_);
            clip-path: url(#SVGID_4_);
}

.st6 {
    -webkit-clip-path: url(#SVGID_6_);
            clip-path: url(#SVGID_6_);
}

.st7 {
    -webkit-clip-path: url(#SVGID_8_);
            clip-path: url(#SVGID_8_);
}

.st8 {
    -webkit-clip-path: url(#SVGID_10_);
            clip-path: url(#SVGID_10_);
}

.st9 {
    fill: none;
}

.st10 {
    -webkit-clip-path: url(#SVGID_12_);
            clip-path: url(#SVGID_12_);
}

.st11 {
    opacity: 0.7;
}

.st12 {
    -webkit-clip-path: url(#SVGID_14_);
            clip-path: url(#SVGID_14_);
}

.st13 {
    opacity: 0.2;
}

.st14 {
    -webkit-clip-path: url(#SVGID_16_);
            clip-path: url(#SVGID_16_);
}

.st15 {
    opacity: 0.3;
    fill: #FFFFFF;
    enable-background: new;
}


@media (prefers-color-scheme: dark) {
    .cm-line .cm-placeholder {
        color: rgb(148 163 184 / var(--tw-text-opacity)) !important;
    }

    .cm-gutters {
        background: rgb(30 41 59) !important;
        color: rgb(100 116 139) !important;
        border: none !important;
    }

    .cm-content {
        /* background: rgb(2 6 23) !important; */
        border: none !important;

    }

    .monaco-editor .margin {
        background: rgb(2 6 23) !important;
    }

    .cm-content {
        caret-color: white !important
    }

    .ͼ1 .cm-cursor,
    .ͼ1 .cm-dropCursor {
        border-left: 1px solid white !important;
        border-right: 1px solid black !important;
    }
}

.cm-content {
    /* background: white; */
    /* padding-left: 10px !important; */
    border: none !important;
}

.ͼo {
    background-color: transparent !important;
}

.md-editor-content .cm-line::selection {
    background: #c3c3c34d !important;
}


.pill-box-animator::before {
    content: "";
    display: block;
    background: linear-gradient(90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(0, 102, 204, 0.75) 50%,
            rgba(255, 255, 255, 0) 100%);
    height: 300px;
    width: 100px;
    transform: translate(0);
    position: absolute;
    animation: rotate 1s linear forwards infinite;
    z-index: 0;
    top: 50%;
    transform-origin: top center;
}


/* electron app bar */
.electron .electron-titlebar {}





.listening {
    /* background: -moz-linear-gradient(45deg, #02e1ba 0%, #26c9f2 29%, #d911f2 66%, #ffa079 100%);
    background: -webkit-linear-gradient(45deg, #02e1ba 0%,#26c9f2 29%,#d911f2 66%,#ffa079 100%);
    background: linear-gradient(45deg, #02e1ba 0%,#26c9f2 29%,#d911f2 66%,#ffa079 100%); */
    /* background-size: 140% 140%; */
    /* -webkit-animation: Gradient 15s ease infinite; */
    /* -moz-animation: Gradient 15s ease infinite; */
    /* animation: Gradient 15s ease infinite; */
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-evenly;
    overflow: hidden;
    position: relative;
}

.listening::before,
.listening::after {
    content: "";
    width: 20vmax;
    height: 20vmax;
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    /* left: 0vmin; */
    bottom: -27vmin;
    right: 0vmin;
    left: -18vmin;
    animation: morph 1s linear infinite alternate, spin 2s linear infinite;
    z-index: 1;
    will-change: border-radius, transform;
    transform-origin: 55% 55%;
    pointer-events: none;
}

.deployment-card-footer {
    display: flex;
}

.deployment-card-footer>.cds--btn,
.deployment-card-footer>.cds--menu-button__container,
.deployment-card-footer>.cds--icon-tooltip {
    flex: 1 1;
    min-inline-size: 0;
}

.deployment-card-footer .cds--btn,
.deployment-card-footer .cds--menu-button__trigger {
    inline-size: 100%;
    max-inline-size: none;
    min-inline-size: 0;
}

.deployment-card-footer .cds--menu-item__label {
    font-size: 0.8125rem;
    font-weight: 500;
}

.deployment-card-footer .cds--icon-tooltip .cds--btn--icon-only {
    inline-size: 100%;
    max-inline-size: none;
    min-inline-size: 0;
}

.cds--menu-button__menu,
.cds--menu-button__menu .cds--popover-content,
.cds--menu {
    box-shadow: none !important;
    border: 0.5px solid var(--cds-border-subtle) !important;
}

.cds--menu-button__menu .cds--menu-item__label,
.cds--menu .cds--menu-item__label {
    font-size: 0.8125rem;
    font-weight: 500;
}

.listening::after {
    width: 20vmax;
    height: 20vmax;
    background: rgba(255, 255, 255, 0.2);
    /* left: 0vmin; */
    bottom: -27vmin;
    left: -10vmin;
    right: 0vmin;
    animation: morph 2s linear infinite alternate, spin 4s linear infinite;
    z-index: 1;
    will-change: border-radius, transform;
    transform-origin: 55% 55%;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,0BAAkB;IAAlB,kBAAkB;;AAEtB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,eAAe;AACnB;;;AAGA;IACI,+BAA+B;IAC/B,yDAAihB;AACrhB;;AAEA,KAAK;AACL;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA,wBAAwB;AACxB;IACI,2CAA2C;AAC/C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;;;AAIA;mBACmB;AACnB,MAAM;;AAEN;IACI;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gCAAgC;;AAEpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,8CAA8C;AAClD;;AAEA;;IAEI;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iCAAyB;YAAzB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,iCAAyB;YAAzB,yBAAyB;AAC7B;;AAEA;IACI,iCAAyB;YAAzB,yBAAyB;AAC7B;;AAEA;IACI,iCAAyB;YAAzB,yBAAyB;AAC7B;;AAEA;IACI,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI;QACI,2DAA2D;IAC/D;;IAEA;QACI,oCAAoC;QACpC,kCAAkC;QAClC,uBAAuB;IAC3B;;IAEA;QACI,wCAAwC;QACxC,uBAAuB;;IAE3B;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI;IACJ;;IAEA;;QAEI,uCAAuC;QACvC,wCAAwC;IAC5C;AACJ;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,WAAW;IACX,cAAc;IACd;;;wCAGoC;IACpC,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,6CAA6C;IAC7C,UAAU;IACV,QAAQ;IACR,4BAA4B;AAChC;;;AAGA,qBAAqB;AACrB,8BAA8B;;;;;;AAM9B;IACI;;0FAEsF;IACtF,gCAAgC;IAChC,mDAAmD;IACnD,gDAAgD;IAChD,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sEAAsE;IACtE,UAAU;IACV,qCAAqC;IACrC,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,SAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;;IAGI,2BAA2B;IAC3B,uDAAuD;AAC3D;;AAEA;;IAEI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,sEAAsE;IACtE,UAAU;IACV,qCAAqC;IACrC,yBAAyB;IACzB,oBAAoB;AACxB","sourcesContent":["body {\r\n    font-family: \"IBM Plex Sans\" !important;\r\n}\r\n\r\nbody>iframe {\r\n    display: none;\r\n}\r\n\r\n.scroll-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    will-change: transform;\r\n}\r\n\r\nli::marker {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n}\r\n\r\n.ga-pill-box__item--select {\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    width: fit-content;\r\n\r\n}\r\n\r\n.ga-pill-box__item--select::before {\r\n    content: attr(title);\r\n    pointer-events: none;\r\n}\r\n\r\n.ͼ42 {\r\n    background-color: transparent !important;\r\n}\r\n\r\n.shape-box {\r\n    border-bottom-left-radius: 100% 250px;\r\n    border-bottom-right-radius: 100% 250px;\r\n    width: calc(100% + 100px);\r\n    margin-left: -50px;\r\n    overflow: hidden;\r\n}\r\n\r\n.ga-pill-box__item--select select {\r\n    padding: 0;\r\n    margin: 0;\r\n    border: none;\r\n    opacity: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.ga-icon__add-circle {\r\n    background-position: 8px center;\r\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDIwIDIwIj48ZyBmaWxsPSIjMmYzMjM3Ij48cGF0aCBkPSJNOS41IDYuNWEuNS41IDAgMSAxIDEgMHYzaDIuOTk4YS41LjUgMCAwIDEgMCAxLjAwMUgxMC41djNhLjUuNSAwIDAgMS0xIDB2LTNoLTNhLjUuNSAwIDEgMSAwLTEuMDAxaDN6Ii8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAgM2E3IDcgMCAxIDEgMCAxNCA3IDcgMCAwIDEgMC0xNHptMCAxYTYgNiAwIDEgMCAwIDEyIDYgNiAwIDAgMCAwLTEyeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9nPjwvc3ZnPg==);\r\n}\r\n\r\n/*  */\r\n.message-container>.day-0~.day-0>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-1~.day-1>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-2~.day-2>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-3~.day-3>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-4~.day-4>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-5~.day-5>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-6~.day-6>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-7~.day-7>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-8~.day-8>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-9~.day-9>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-10~.day-10>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-11~.day-11>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-12~.day-12>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-13~.day-13>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-14~.day-14>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-15~.day-15>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-16~.day-16>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-17~.day-17>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-18~.day-18>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-19~.day-19>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-20~.day-20>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-21~.day-21>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-22~.day-22>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-23~.day-23>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-24~.day-24>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-25~.day-25>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-26~.day-26>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-27~.day-27>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-28~.day-28>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-29~.day-29>.date-header {\r\n    display: none;\r\n}\r\n\r\n.message-container>.day-30~.day-30>.date-header {\r\n    display: none;\r\n}\r\n\r\n/* start of react flow */\r\n.wmde-markdown {\r\n    font-family: \"Rubik\", sans-serif !important;\r\n}\r\n\r\n.workflow-panel-animation .react-flow__viewport {\r\n    transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.workflow-node-animation .react-flow__node {\r\n    transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.md-editor-toolbar-warp {\r\n    border: none !important;\r\n}\r\n\r\n.react-flow__attribution {\r\n    position: absolute;\r\n    bottom: 0px;\r\n    right: 0px;\r\n}\r\n\r\n\r\n\r\n/* input[type=\"radio\"]:checked + span {\r\n  display: block; */\r\n/* } */\r\n\r\n.gridBody {\r\n    fill: white\r\n}\r\n\r\n.monaco-editor {\r\n    position: absolute !important;\r\n}\r\n\r\n.normal-text .ͼ1 .cm-scroller {\r\n    font-family: \"Rubik\", sans-serif !important;\r\n}\r\n\r\n.cm-content {\r\n    white-space: pre-wrap !important;\r\n\r\n}\r\n\r\n.markdown-editor .cm-line {\r\n    font-family: \"Rubik\", sans-serif;\r\n}\r\n\r\n.cm-line .cm-placeholder {\r\n    opacity: 0.5;\r\n    color: rgb(71 85 105 / var(--tw-text-opacity));\r\n}\r\n\r\n.monaco-editor,\r\n.monaco-editor-background {\r\n    background: transparent !important\r\n}\r\n\r\n.markdown-viewer-with-uiw .wmde-markdown {\r\n    font-family: \"Rubik\", sans-serif;\r\n}\r\n\r\n.monaco-editor .margin-view-overlays .current-line,\r\n.monaco-editor .view-overlays .current-line {\r\n    border: none !important;\r\n}\r\n\r\n.cm-scroller {\r\n    line-height: 30px !important;\r\n}\r\n\r\n.margin-view-overlays {\r\n    padding-left: 10px;\r\n}\r\n\r\n/* hide readonly tooltip */\r\n.monaco-editor-overlaymessage {\r\n    display: none !important;\r\n}\r\n\r\n.cm-editor {\r\n    outline: none !important;\r\n\r\n}\r\n\r\n.md-editor-content {\r\n    border-radius: 10px;\r\n}\r\n\r\n.full-screen .cm-editor {\r\n    height: 78vh !important;\r\n}\r\n\r\n\r\n.st0 {\r\n    display: none;\r\n}\r\n\r\n.st1 {\r\n    display: inline;\r\n}\r\n\r\n.st2 {\r\n    opacity: 0.29;\r\n}\r\n\r\n.st3 {\r\n    fill: #FFFFFF;\r\n}\r\n\r\n.st4 {\r\n    clip-path: url(#SVGID_2_);\r\n    fill: #FFFFFF;\r\n}\r\n\r\n.st5 {\r\n    clip-path: url(#SVGID_4_);\r\n}\r\n\r\n.st6 {\r\n    clip-path: url(#SVGID_6_);\r\n}\r\n\r\n.st7 {\r\n    clip-path: url(#SVGID_8_);\r\n}\r\n\r\n.st8 {\r\n    clip-path: url(#SVGID_10_);\r\n}\r\n\r\n.st9 {\r\n    fill: none;\r\n}\r\n\r\n.st10 {\r\n    clip-path: url(#SVGID_12_);\r\n}\r\n\r\n.st11 {\r\n    opacity: 0.7;\r\n}\r\n\r\n.st12 {\r\n    clip-path: url(#SVGID_14_);\r\n}\r\n\r\n.st13 {\r\n    opacity: 0.2;\r\n}\r\n\r\n.st14 {\r\n    clip-path: url(#SVGID_16_);\r\n}\r\n\r\n.st15 {\r\n    opacity: 0.3;\r\n    fill: #FFFFFF;\r\n    enable-background: new;\r\n}\r\n\r\n\r\n@media (prefers-color-scheme: dark) {\r\n    .cm-line .cm-placeholder {\r\n        color: rgb(148 163 184 / var(--tw-text-opacity)) !important;\r\n    }\r\n\r\n    .cm-gutters {\r\n        background: rgb(30 41 59) !important;\r\n        color: rgb(100 116 139) !important;\r\n        border: none !important;\r\n    }\r\n\r\n    .cm-content {\r\n        /* background: rgb(2 6 23) !important; */\r\n        border: none !important;\r\n\r\n    }\r\n\r\n    .monaco-editor .margin {\r\n        background: rgb(2 6 23) !important;\r\n    }\r\n\r\n    .cm-content {\r\n        caret-color: white !important\r\n    }\r\n\r\n    .ͼ1 .cm-cursor,\r\n    .ͼ1 .cm-dropCursor {\r\n        border-left: 1px solid white !important;\r\n        border-right: 1px solid black !important;\r\n    }\r\n}\r\n\r\n.cm-content {\r\n    /* background: white; */\r\n    /* padding-left: 10px !important; */\r\n    border: none !important;\r\n}\r\n\r\n.ͼo {\r\n    background-color: transparent !important;\r\n}\r\n\r\n.md-editor-content .cm-line::selection {\r\n    background: #c3c3c34d !important;\r\n}\r\n\r\n\r\n.pill-box-animator::before {\r\n    content: \"\";\r\n    display: block;\r\n    background: linear-gradient(90deg,\r\n            rgba(255, 255, 255, 0) 0%,\r\n            rgba(0, 102, 204, 0.75) 50%,\r\n            rgba(255, 255, 255, 0) 100%);\r\n    height: 300px;\r\n    width: 100px;\r\n    transform: translate(0);\r\n    position: absolute;\r\n    animation: rotate 1s linear forwards infinite;\r\n    z-index: 0;\r\n    top: 50%;\r\n    transform-origin: top center;\r\n}\r\n\r\n\r\n/* electron app bar */\r\n.electron .electron-titlebar {}\r\n\r\n\r\n\r\n\r\n\r\n.listening {\r\n    /* background: -moz-linear-gradient(45deg, #02e1ba 0%, #26c9f2 29%, #d911f2 66%, #ffa079 100%);\r\n    background: -webkit-linear-gradient(45deg, #02e1ba 0%,#26c9f2 29%,#d911f2 66%,#ffa079 100%);\r\n    background: linear-gradient(45deg, #02e1ba 0%,#26c9f2 29%,#d911f2 66%,#ffa079 100%); */\r\n    /* background-size: 140% 140%; */\r\n    /* -webkit-animation: Gradient 15s ease infinite; */\r\n    /* -moz-animation: Gradient 15s ease infinite; */\r\n    /* animation: Gradient 15s ease infinite; */\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    justify-content: space-evenly;\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n.listening::before,\r\n.listening::after {\r\n    content: \"\";\r\n    width: 20vmax;\r\n    height: 20vmax;\r\n    position: absolute;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    /* left: 0vmin; */\r\n    bottom: -27vmin;\r\n    right: 0vmin;\r\n    left: -18vmin;\r\n    animation: morph 1s linear infinite alternate, spin 2s linear infinite;\r\n    z-index: 1;\r\n    will-change: border-radius, transform;\r\n    transform-origin: 55% 55%;\r\n    pointer-events: none;\r\n}\r\n\r\n.deployment-card-footer {\r\n    display: flex;\r\n}\r\n\r\n.deployment-card-footer>.cds--btn,\r\n.deployment-card-footer>.cds--menu-button__container,\r\n.deployment-card-footer>.cds--icon-tooltip {\r\n    flex: 1 1 0;\r\n    min-inline-size: 0;\r\n}\r\n\r\n.deployment-card-footer .cds--btn,\r\n.deployment-card-footer .cds--menu-button__trigger {\r\n    inline-size: 100%;\r\n    max-inline-size: none;\r\n    min-inline-size: 0;\r\n}\r\n\r\n.deployment-card-footer .cds--menu-item__label {\r\n    font-size: 0.8125rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.deployment-card-footer .cds--icon-tooltip .cds--btn--icon-only {\r\n    inline-size: 100%;\r\n    max-inline-size: none;\r\n    min-inline-size: 0;\r\n}\r\n\r\n.cds--menu-button__menu,\r\n.cds--menu-button__menu .cds--popover-content,\r\n.cds--menu {\r\n    box-shadow: none !important;\r\n    border: 0.5px solid var(--cds-border-subtle) !important;\r\n}\r\n\r\n.cds--menu-button__menu .cds--menu-item__label,\r\n.cds--menu .cds--menu-item__label {\r\n    font-size: 0.8125rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.listening::after {\r\n    width: 20vmax;\r\n    height: 20vmax;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    /* left: 0vmin; */\r\n    bottom: -27vmin;\r\n    left: -10vmin;\r\n    right: 0vmin;\r\n    animation: morph 2s linear infinite alternate, spin 4s linear infinite;\r\n    z-index: 1;\r\n    will-change: border-radius, transform;\r\n    transform-origin: 55% 55%;\r\n    pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
